module.exports = __webpack_public_path__ + "img/authority-active.e2227e8f.svg";